import { useState } from "react";
import "../ProjectCard/ProjectCard.css";
import { FaArrowRight } from "react-icons/fa6";

const ProjectCard = ({ id, title, text }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`project-card ${flipped ? "flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="card-inner">
        <div
          className="card-face card-front"
          style={{ backgroundImage: `url(/project_${id}.png)` }}
        >
          <div className="card-front-title-section">
            <h3>{title}</h3>
            <div className="card-front-arrow"><FaArrowRight /></div>
            </div>
        </div>
        <div className="card-face card-back">
          <div className="card-back-content">
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;